import { CCol, CLabel, CSelect } from "@coreui/react";
import { useEffect, useState } from "react";
import { apiCallResponse } from "src/_apiConfig/apiCall";

const DropDownCircle = (props) => {
  const [items, setItems] = useState([]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getCircleList();
    // eslint-disable-next-line
  }, [props.isClear]);

  const getCircleList = async () => {
    let url = `Circle_Master`;
    if (props.isOfficer === true) {
      url = `Circle_Master/getOfficers`;
    }
    await apiCallResponse(url).then((res) => {
      if (res.success) {
        console.log("apiCallResponse: ", url, res.data);
        if (props.isOfficer === true) {
          console.log("isOfficer", res.data);
          const sortedData = res.data.sort((a, b) =>
            a.circleName.localeCompare(b.circleName)
          );

          const uniqueDataMap = new Map();

          sortedData.forEach((item) => {
            const { circleName, circleId } = item;
            if (!uniqueDataMap.has(circleName)) {
              uniqueDataMap.set(circleName, {
                value: circleId,
                name: circleName,
              });
            }
          });

          const uniqueGroupedData = Array.from(uniqueDataMap.values());

          // const sortedGroupedData = Object.keys(groupedData)
          //   .sort((a, b) => a.localeCompare(b))
          //   .reduce((acc, key) => {
          //     acc[key] = groupedData[key];
          //     return acc;
          //   }, {});

          console.log("groupedData", uniqueGroupedData);
          setItems(uniqueGroupedData);
        } else {
          setItems(res.data);
        }
      }
    });
  };

  return (
    <CCol xl={props.xl || 3} sm={props.sm || 6}>
      <CLabel>Circle Name :</CLabel>
      <CSelect
        aria-label="Default select example"
        name={props.name}
        value={props.value}
        onChange={props.onChange}
      >
        <option value="">Select Circle</option>
        {/* {items
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, key) => (
            <option key={key} value={item.name}>
              {item.name}
            </option>
          ))} */}

        {props.isValueLabelSame === false
          ? items
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((item, key) => (
                <option key={key} value={item.value}>
                  {item.name}
                </option>
              ))
          : items
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((item, key) => (
                <option key={key} value={item.name}>
                  {item.name}
                </option>
              ))}
      </CSelect>
    </CCol>
  );
};
export default DropDownCircle;
